module.exports = __webpack_public_path__ + "img/299-23a5f3.png";